module.exports = __webpack_public_path__ + "774897dfc2990f80420d99de98427a04.png";